import { MenuRoute } from '../../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the FixedAsset Visma integration sub-module.
 */
export const FIXED_ASSET_VISMA_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/fixed-asset/visma/register-visma',
    labelKey: 'FixedAsset.registerVisma',
    icon: '/assets/tablerIcons/outline/plug-connected.svg',
    moduleId: 26,
    groupLabelKey: 'MenuRoutes.group.fixedAssetVisma'
  },
  {
    path: '/fixed-asset/visma/import-fixed-asset-from-visma',
    labelKey: 'FixedAsset.importFromVisma',
    icon: '/assets/tablerIcons/outline/file-import.svg',
    moduleId: 26,
    groupLabelKey: 'MenuRoutes.group.fixedAssetVisma'
  },
  {
    path: '/fixed-asset/visma/visma-change-log',
    labelKey: 'FixedAsset.vismaChangeLog',
    icon: '/assets/tablerIcons/outline/history.svg',
    moduleId: 26,
    groupLabelKey: 'MenuRoutes.group.fixedAssetVisma'
  },
  {
    path: '/fixed-asset/visma/outgoing-transaction',
    labelKey: 'FixedAsset.outgoingTransaction',
    icon: '/assets/tablerIcons/outline/arrow-right-circle.svg',
    moduleId: 26,
    groupLabelKey: 'MenuRoutes.group.fixedAssetVisma'
  }
];
